module.exports = __webpack_public_path__ + "static/img/pic111.92d5f6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt/pic111.jpg
// module id = 0Q7t
// module chunks = 1